module.exports = __webpack_public_path__ + "media/slot-game/sushibox-8334d8b0.svg";